module.exports = __webpack_public_path__ + "static/media/cadastro.1791858b.svg";